/* stats/sagas*/
import {
  select,
  all,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { has, isNil, includes, isEmpty } from "ramda";
import { Stats, StatsActionTypes } from "./types";
import { fetch } from "../../repo/stats";
import { fetchRequest, fetchError, fetchSuccess } from "./actions";
import { dirty } from "../session/actions";
import { Error, isAuthError } from "../";

function* handleFetch(action: ReturnType<typeof fetchRequest>) {
  try {
    const stats = yield fetch(action.payload.id, action.payload.params);
    if (stats.errors && !isEmpty(stats.errors)) {
      if (isAuthError(stats.errors)) {
        yield put(dirty());
      }
      yield put(fetchError(JSON.stringify(stats.errors)));
    } else {
      yield put(fetchSuccess(stats));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(StatsActionTypes.FETCH, handleFetch);
}

export default function* statsSaga() {
  yield all([fork(watchFetchRequest)]);
}
